import React from "react";
import '../App.css';
import SimpleSlider from "../components/carousel";
import { useTranslation } from "react-i18next";

const SPLINE_URL_LIGHT = "https://prod.spline.design/qQTkJsMOPm1h37Jc-rE2/scene.hanacode";
const SPLINE_URL_DARK = "https://prod.spline.design/qQTkJsMOPm1h37Jc-V7y/scene.hanacode";

export const Home = ({ theme }) =>{
    const { t } = useTranslation()
    const splineUrl = theme === 'dark' ? SPLINE_URL_DARK : SPLINE_URL_LIGHT;
    return(
        <> 
        <div className='container start'>
            <div className="row">
                
                <div className="col d-flex align-items-start flex-column intro">
                    <h1>{t("home_designer")}</h1>
                    <p>{t("home_hello")}</p>
                </div>
                <div className="col">
                <hana-viewer
                    key={splineUrl}
                    class="image-1"
                    url={splineUrl}
                ></hana-viewer>
                </div>
            </div>
            <div className="projectsslider">
            <SimpleSlider/>

            </div>
        </div>

        </>
    )
}

export default Home;
